"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FakePromise = exports.default = exports.DelayedPromise = void 0;

var _Symbol = function () {
  if (global.Symbol) return global.Symbol;
  var SymID = 0;
  var Symbols = [];
  return function _Symbol2(text) {
    var ST = "$_Symbol_" + text;

    if (Symbols.indexOf(ST) == -1) {
      Symbols.push(ST);
      return ST;
    }

    ST = "".concat(ST, "_").concat(SymID++);
    Symbols.push(ST);
    return ST;
  };
}();

var SetState = _Symbol('SetState');

var State = _Symbol('State');

var Handlers = _Symbol('Handlers');

var Queue = _Symbol('Queue');

var Enqueue = _Symbol('Enqueue');

var Dispatch = _Symbol('Dispatch');

var NoFollow = _Symbol('NoFollow');

var PROMISE = _Symbol('PROMISE');

var hasNextTick = false;

var doNextTick = function doNextTick() {
  if (!hasNextTick) {
    hasNextTick = true;
    setTimeout(function () {
      hasNextTick = false;
      Promise.dispatchQueue();
    }, 0);
  }
};

var Promise =
/*#__PURE__*/
function () {
  babelHelpers.createClass(Promise, null, [{
    key: PROMISE,
    get: function get() {
      return PROMISE;
    }
  }]);

  function Promise(executor) {
    var _this = this;

    babelHelpers.classCallCheck(this, Promise);

    if (typeof executor != 'function') {
      throw new TypeError('executor is not a function');
    }

    this[State] = {
      current: 'pending',
      stateSet: 0,
      success: null,
      value: void 0
    };
    this[Handlers] = [];
    Promise.pending.push(this);

    try {
      var resolve = function resolve(value) {
        return _this[SetState](true, value);
      };

      var reject = function reject(value) {
        return _this[SetState](false, value, 0, false);
      };

      resolve[NoFollow] = function (value) {
        return _this[SetState](true, value, 0, false);
      };

      reject[NoFollow] = function (value) {
        return _this[SetState](false, value, 0, false);
      };

      executor(resolve, reject);
    } catch (e) {
      this[SetState](false, e, 0, false);
    }
  }

  babelHelpers.createClass(Promise, [{
    key: SetState,
    value: function value(success, _value, stateSet, follow) {
      var _this2 = this;

      if (stateSet === void 0) stateSet = 0;
      if (follow === void 0) follow = true;

      if (this[State].current == 'pending' && stateSet === this[State].stateSet) {
        this[State].stateSet = stateSet + 1;

        if (follow && _value && (babelHelpers.typeof(_value) == 'object' || typeof _value == 'function') && 'then' in _value) {
          try {
            var then = _value.then;

            if (typeof then == 'function') {
              try {
                then.call(_value, function (result) {
                  _this2[SetState](true, result, stateSet + 1);
                }, function (error) {
                  _this2[SetState](false, error, stateSet + 1);
                });
              } catch (e) {
                this[SetState](false, e, stateSet + 1, false);
              }

              return;
            }
          } catch (e) {
            success = false;
            _value = e;
          }
        }

        Object.assign(this[State], {
          current: success ? 'resolved' : 'rejected',
          success: success,
          value: _value
        });
        Promise.pending.splice(Promise.pending.indexOf(this), 1);
        this[Enqueue]();
      }
    }
  }, {
    key: Enqueue,
    value: function value() {
      if (Promise[Queue].indexOf(this) == -1) {
        Promise[Queue].push(this);
      }

      doNextTick();
    }
  }, {
    key: "then",
    value: function then(onFulfilled, onRejected) {
      var _this3 = this;

      var R = new this.constructor(function (resolve, reject) {
        _this3[Handlers].push({
          resolved: function resolved(value) {
            var result = value;

            if (onFulfilled && typeof onFulfilled == 'function') {
              try {
                result = onFulfilled(value);

                if (R === result) {
                  throw new TypeError("then() handler cannot return this promise");
                }
              } catch (error) {
                reject[NoFollow](error);
                return;
              }
            }

            if (result && (babelHelpers.typeof(result) == 'object' || typeof result == 'function') && 'then' in result) {
              try {
                var then = result.then;
                if (then && typeof then == 'function') then.call(result, resolve, reject);else resolve(result);
              } catch (e) {
                reject[NoFollow](e);
              }
            } else resolve(result);
          },
          rejected: function rejected(value) {
            var result = value;

            if (onRejected && typeof onRejected == 'function') {
              try {
                result = onRejected(value);

                if (R === result) {
                  throw new TypeError("catch() handler cannot return this promise");
                }
              } catch (error) {
                reject[NoFollow](error);
                return;
              }
            } else {
              reject(value);
              return;
            }

            if (result && (babelHelpers.typeof(result) == 'object' || typeof result == 'function') && 'then' in result) {
              try {
                var then = result.then;
                if (typeof then == 'function') then.call(result, resolve, reject);else resolve(result);
              } catch (e) {
                reject[NoFollow](e);
              }
            } else resolve(result);
          }
        });

        if (_this3[State].current != 'pending') _this3[Enqueue]();
      });
      return R;
    }
  }, {
    key: "catch",
    value: function _catch(onRejected) {
      return this.then(null, onRejected);
    }
  }, {
    key: Dispatch,
    value: function value() {
      var _this4 = this;

      if (this[State].current == 'pending') return;
      var H = this[Handlers];
      this[Handlers] = [];
      H.forEach(function (handler) {
        handler[_this4[State].current](_this4[State].value);
      });
    }
  }], [{
    key: "all",
    value: function all(iterable) {
      var _this5 = this;

      var iterator;

      try {
        iterator = iterable[_Symbol.iterator]();
      } catch (e) {
        return this.reject(e);
      }

      var items = [],
          item;

      while (item = iterator.next()) {
        if (item.done) {
          break;
        }

        items.push(item.value);
      }

      if (!items.length) {
        return this.resolve([]);
      }

      if (items.filter(function (item) {
        return babelHelpers.instanceof(item, _this5);
      }).length == 0) {
        return new this(function (resolve) {
          return resolve(items);
        });
      }

      return new this(function (resolve, reject) {
        items = items.map(function (item) {
          if (babelHelpers.instanceof(item, _this5)) return item;
          return _this5.resolve(item);
        });
        var result = [],
            matched = {},
            thrown = false;
        items.forEach(function (item, index) {
          item.then(function (value) {
            if (thrown) return;
            result[index] = value;
            matched[index] = true;

            if (Object.keys(matched).length == items.length) {
              resolve(result);
            }
          }, function (error) {
            if (thrown) return;
            thrown = true;
            matched = null;
            result = null;
            items = null;
            reject(error);
          });
        });
      });
    }
  }, {
    key: "race",
    value: function race(iterable) {
      var _this6 = this;

      return new this(function (resolve, reject) {
        var iterator = iterable[_Symbol.iterator]();

        var items = [],
            item;

        while (item = iterator.next()) {
          if (item.done) {
            break;
          }

          items.push(item.value);
        }

        var q = items.filter(function (item) {
          return !babelHelpers.instanceof(item, _this6);
        }).shift();

        if (q) {
          resolve(q);
          return;
        }

        var finished = false;
        items.forEach(function (item, index) {
          item.then(function (value) {
            if (finished) return;
            resolve(value);
          }, function (error) {
            if (finished) return;
            reject(error);
          });
        });
      });
    }
  }, {
    key: "resolve",
    value: function resolve(value) {
      if (babelHelpers.instanceof(value, this)) return value;

      if (value && (babelHelpers.typeof(value) == 'object' || typeof value == 'function') && 'then' in value) {
        return new this(function (resolve, reject) {
          value.then(resolve, reject);
        });
      }

      var P = new this(function () {});
      P[SetState](true, value);
      return P;
    }
  }, {
    key: "reject",
    value: function reject(value) {
      var P = new this(function () {});
      P[SetState](false, value);
      return P;
    }
  }, {
    key: "dispatchQueue",
    value: function dispatchQueue() {
      var Q = Promise[Queue];
      Promise[Queue] = [];
      Q.forEach(function (queueItem) {
        queueItem[Dispatch]();
      });
      return Q.length > 0;
    }
  }]);
  return Promise;
}();

exports.FakePromise = Promise;
;
Promise[Queue] = [];
Promise.pending = [];
var Value = global.Promise || Promise;

var DelayedPromise =
/*#__PURE__*/
function () {
  function DelayedPromise(executor) {
    babelHelpers.classCallCheck(this, DelayedPromise);
    this._executor = executor;
  }

  babelHelpers.createClass(DelayedPromise, [{
    key: "_getRealPromise",
    value: function _getRealPromise() {
      if (this._promise) return this._promise;
      return this._promise = new Value(this._executor);
    }
  }, {
    key: "then",
    value: function then() {
      var _this$_getRealPromise;

      return (_this$_getRealPromise = this._getRealPromise()).then.apply(_this$_getRealPromise, arguments);
    }
  }, {
    key: "catch",
    value: function _catch() {
      var _this$_getRealPromise2;

      return (_this$_getRealPromise2 = this._getRealPromise()).catch.apply(_this$_getRealPromise2, arguments);
    }
  }]);
  return DelayedPromise;
}();

exports.DelayedPromise = DelayedPromise;
var _default = Value;
exports.default = _default;